export const LOW_MARGIN_THRESHOLD = 50;
export const LOW_MARGIN_CONFIRMATION_MESSAGES = {
  survey:
    'You have entered a Target Margin value that is below the average Margin set for this account. We recommend reviewing the Banked Margin for the project before you confirm you want to proceed',
  marginOverrideSurvey:
    'You have entered a Target Margin that is below the average margin set for this account. Review the Banked Margin for the project before you confirm you want to proceed.',
} as const;
export const DEFAULT_TARGET_MARGIN = LOW_MARGIN_THRESHOLD;

export const EPC_ESTIMATE_DEBOUNCE_MS = 500;

export const MIN_BUYER_CPI = 0.01;

export const EPC_NOT_AVAILABLE = '—';
export const TARGET_MARGIN_NOT_APPLICABLE = 'N/A';
export const LOW_MARGIN_CONFIRMATION_TITLES = {
  /** Bulk edit. */
  survey: 'Margin Confirmation',
  /** Create/Edit Survey. */
  marginOverrideSurvey: 'Target margin validation',
} as const;
export const LOW_MARGIN_DRAWER_HEADING = 'Low target margin';

export const MARGIN_UPDATE_NOT_ALLOWED_ERROR =
  'New Margin value cannot be set in a non Target Margin survey.';
export const EMPTY_MARGIN_VALUE = 'New Margin value cannot be empty or 0.';
